import React, { Component } from "react";
import "../../sidebar/style.css";
import axios from "axios";
import { Button, Row } from "shards-react";
import "react-notifications/lib/notifications.css";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";

class WorkshopForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: null,
      domain: null,
      date: null,
      session_link: null,
      workshopID: null,
      quiz_link: null,
      content_link: null,
      upload: false,
    };
  }

  fetchWorkshopData = (id) => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/admin/atl-tinkerpreneur/${id}`, {
        headers: { "x-access-token": localStorage.getItem("jwtToken") },
      })
      .then((res) => {
        const {
          domain,
          title,
          date,
          session_link,
          quiz_link,
          content_link,
        } = res.data.data;

        this.setState({
          domain,
          title,
          date,
          session_link,
          quiz_link,
          content_link,
        });
      })
      .catch((err) => {
        console.error(err);
        this.createNotification("error");
      });
  };

  createNotification = (type, message) => {
    switch (type) {
      case "success":
        NotificationManager.success(
          "Success message",
          "Successfully Updated",
          1000
        );
        setTimeout(() => {
          this.UpdateChecker();
        }, 2000);
        break;
      case "error":
        NotificationManager.error(message, "Error message", 1000);
        break;
      default:
        break;
    }
  };

  UpdateChecker = () => {
    if (this.state.upload === true) {
      this.props.history.push("/workshops");
    }
  };

  onSubmit = (e) => {
    e.preventDefault();
    const {
      domain,
      title,
      date,
      session_link,
      quiz_link,
      workshopID,
      content_link,
      recording_link,
    } = this.state;

    fetch(
      `${process.env.REACT_APP_API_URL}/admin/atl-tinkerpreneur/${workshopID}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": localStorage.getItem("jwtToken"),
        },
        body: JSON.stringify({
          domain,
          title,
          date,
          session_link,
          quiz_link,
          content_link,
          recording_link,
        }),
      }
    )
      .then((res) => {
        if (res.status === 200) {
          this.setState({ upload: true });
          this.createNotification("success", null);
        } else if (res.status === 422) {
          res.json().then((data) => {
            this.setState({ errors: data.error });
          });
        } else {
          this.createNotification(
            "error",
            `Unexpected status code: ${res.status}`
          );
        }
      })
      .catch((error) => {
        this.createNotification("error", error.message || "Unknown error");
      });
  };

  componentDidMount() {
    const { match } = this.props;
    if (match.params.workshopID) {
      this.setState({ workshopID: match.params.workshopID });
      this.fetchWorkshopData(match.params.workshopID);
    }
  }

  render() {
    return (
      <React.Fragment>
        <NotificationContainer />
        <section className="hero-section pt-50 pb-50">
          <div className="container">
            <div className="col-md-12 col-lg-12 ">
              <h1 className="event-title">Update Workshop</h1>
              <div className="card login-signup-card shadow-lg mb-0">
                <div className="card-body px-md-5 py-5">
                  <form onSubmit={this.onSubmit}>
                    <div className="row">
                      <div className="col-md-6">
                        <label className="pb-1">Domain Name</label>
                        <input
                          onChange={(event) =>
                            this.setState({ domain: event.target.value })
                          }
                          value={this.state.domain || ""}
                          type="text"
                          name="domain"
                          className="form-control"
                          placeholder="Please enter domain name"
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="pb-1">Workshop Title</label>
                        <input
                          onChange={(event) =>
                            this.setState({ title: event.target.value })
                          }
                          value={this.state.title || ""}
                          type="text"
                          name="title"
                          className="form-control"
                          placeholder="Please enter workshop title"
                          required
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <label className="pb-1">Scheduled Date</label>
                        <input
                          onChange={(event) =>
                            this.setState({ date: event.target.value })
                          }
                          value={this.state.date || ""}
                          type="date"
                          name="date"
                          className="form-control"
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="pb-1">Live Session Link</label>
                        <input
                          onChange={(event) =>
                            this.setState({ session_link: event.target.value })
                          }
                          value={this.state.session_link || ""}
                          type="text"
                          name="domain"
                          className="form-control"
                          placeholder="Add live session link here"
                        />
                      </div>
                    </div>
                    <div className="row mt-4">
                      <div className="col-12">
                        <div className="alert alert-info p-3">
                          <strong>
                            After workshop completion, update the below fields:
                          </strong>
                          <p className="mb-0 mt-1">
                            Please provide all relevant links for participants
                            to access workshop materials.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-md-6">
                        <label className="pb-1">Quiz Link</label>
                        <input
                          onChange={(event) => {
                            this.setState({ quiz_link: event.target.value });
                          }}
                          type="text"
                          value={this.state.quiz_link || ""}
                          name="quiz_link"
                          className="form-control"
                          placeholder=""
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="pb-1">Session Content Link</label>
                        <input
                          onChange={(event) => {
                            this.setState({ content_link: event.target.value });
                          }}
                          type="text"
                          value={this.state.content_link || ""}
                          name="content_link"
                          className="form-control"
                          placeholder=""
                        />
                      </div>
                    </div>
                    <Button type="submit" value="submit" className="submit-btn">
                      Submit
                    </Button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default WorkshopForm;
